<template>
  <v-dialog persistent max-width="350" :value="true">
    <v-card>
      <v-card-title>Lookup BC Licensee</v-card-title>
      <v-divider/>
      <v-card-text class="pb-0 pt-2 px-0">
        <v-form ref="form">
          <v-container>
            <v-row>
              <v-col>
                <v-btn-toggle v-model="by" mandatory @change="lookup=''">
                  <v-btn x-small>Licensee #</v-btn>
                  <v-btn x-small>Name</v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field :label="by?'Name':'Licensee #'" v-model="lookup" :rules="[fieldRules.required]" dense outlined/>
              </v-col>
              <v-spacer/>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="$emit('done')">Cancel</v-btn>
        <v-btn color="primary" @click="save">Lookup</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
name: 'LookupLicencee',
props: {
  customer: {type:Object, required:true},
},
data() {
  return {
    by: 0,
    lookup: ''
  }
},
methods: {
  async save() {
    if (!this.$refs.form.validate())
      return;

    const results = await this.$apiCall(`query LookupLicensee($lookup: String!, $number: Boolean!) {
                                            bcLookupLicensee(lookup:$lookup, number:$number) {
                                              number,name,address,city,postalCode
                                            }
                                          }`,
                                        {lookup:this.lookup, number:this.by===0});
    if (!results.error) {
      const licensee = results.data.bcLookupLicensee;
      this.customer.name = licensee.name;
      if (!this.customer.billingAddress)
        this.customer.billingAddress = {};
      this.customer.billingAddress.line1 = licensee.address;
      this.customer.billingAddress.city = licensee.city;
      this.customer.billingAddress.province = 'BC';
      this.customer.billingAddress.postalCode = licensee.postalCode;
      this.customer.type = 'LIC';
      this.customer.license = licensee.number;
      this.$emit('done');
    }
  }
}
}
</script>